import { tutoringSharedTypes } from './Constants';

export function signUpLiveLesson(data, callback) {
	return {
		type: tutoringSharedTypes.SIGN_UP_LIVE_LESSON_REQUEST,
		payload: { data, callback },
	};
}

export function signUpLiveLessonSuccess() {
	return {
		type: tutoringSharedTypes.SIGN_UP_LIVE_LESSON_SUCCESS,
	};
}

export function signUpLiveLessonError() {
	return {
		type: tutoringSharedTypes.SIGN_UP_LIVE_LESSON_ERROR,
	};
}

export function sendLogsRequest(data, callback) {
	return {
		type: tutoringSharedTypes.SEND_LOGS_REQUEST,
		payload: { data, callback },
	};
}

export function sendLogsSuccess(data) {
	return {
		type: tutoringSharedTypes.SEND_LOGS_SUCCESS,
		payload: { data },
	};
}

export function sendLogsError() {
	return {
		type: tutoringSharedTypes.SEND_LOGS_ERROR,
	};
}
